import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { LOGO_WORDMARK } from "@/lib/brand";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back, champ.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="grain min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md border border-white/10 bg-[#0a0a0a] p-8 md:p-10"
      >
        <img
          src={LOGO_WORDMARK}
          alt="Susegado Strike"
          className="h-14 w-auto mb-2"
        />
        <p className="font-oswald uppercase tracking-[0.3em] text-xs text-[#A3A3A3] mb-8">
          Admin Control Room
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          <div>
            <label className="font-oswald uppercase tracking-[0.2em] text-xs text-[#A3A3A3]">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="field-underline w-full font-dm text-[#FAFAFA] py-3 mt-2"
              placeholder="admin@susegadostrike.com"
            />
          </div>
          <div>
            <label className="font-oswald uppercase tracking-[0.2em] text-xs text-[#A3A3A3]">Password</label>
            <input
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field-underline w-full font-dm text-[#FAFAFA] py-3 mt-2"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="font-oswald uppercase tracking-[0.2em] text-sm bg-[#E85A24] text-black px-8 py-4 hover:bg-[#FF7038] transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Enter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
